import { ErrorImportType } from "@/services/export.service";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ImportReportError extends Vue {
  @Prop({ default: ErrorImportType.PARSE_ERROR })
  public errorType!: ErrorImportType;

  close(): void {
    this.$emit("closed");
  }

  get errorTitle(): string {
    switch (this.errorType) {
      case ErrorImportType.VERSION_ERROR:
        return this.$t("components.options.popinErrors.version.title").toString();
      default:
        return this.$t("components.options.popinErrors.parse.title").toString();
    }
  }

  get errorDescription(): string {
    switch (this.errorType) {
      case ErrorImportType.VERSION_ERROR:
        return this.$t("components.options.popinErrors.version.description").toString();
      default:
        return this.$t("components.options.popinErrors.parse.description").toString();
    }
  }
}
